import { useEffect, useRef, useState } from "react";
import type { PlatformClient } from "../../platform/supabase";

const STAFF_CLAIM_KEY="rs-career-staff-claim-token";

export function StaffAccessClaimPage({client}:{client:PlatformClient}){
  const initialToken=
    new URLSearchParams(window.location.search).get("token")
    || window.sessionStorage.getItem(STAFF_CLAIM_KEY)
    || "";

  const [token,setToken]=useState(initialToken);
  const [busy,setBusy]=useState(false);
  const [message,setMessage]=useState("");
  const [landingUrl,setLandingUrl]=useState("");
  const attempted=useRef(false);

  async function claim(value=token){
    if(!value.trim()) return;
    setBusy(true);
    setMessage("");

    const {data,error}=await client.rpc("claim_staff_access",{
      p_token:value.trim()
    });

    setBusy(false);

    if(error){
      setMessage(error.message);
      return;
    }

    const result=data as {status?:string;landingUrl?:string};
    if(result.status==="CLAIMED"){
      window.sessionStorage.removeItem(STAFF_CLAIM_KEY);
      setLandingUrl(result.landingUrl || window.location.origin+"/");
      setMessage("소속과 권한이 연결됐습니다.");
      return;
    }

    setMessage("초대 연결 결과를 확인할 수 없습니다.");
  }

  useEffect(()=>{
    if(!initialToken || attempted.current) return;
    attempted.current=true;
    void claim(initialToken);
  },[]);

  return (
    <section className="staff-claim-card">
      <p className="eyebrow">Access Invitation</p>
      <h2>조직 초대와 내 Google 계정을 연결합니다</h2>
      <p>초대한 이메일이 지정된 경우 현재 로그인한 Google 계정 이메일과 정확히 일치해야 합니다.</p>

      <label>초대 코드
        <input value={token} onChange={(event)=>setToken(event.target.value)} placeholder="64자리 초대 코드" autoComplete="off" />
      </label>

      {!landingUrl ? (
        <button className="primary" disabled={busy || !token.trim()} onClick={()=>claim()}>
          {busy ? "권한 연결 중…" : "초대 수락"}
        </button>
      ):(
        <button className="primary" onClick={()=>window.location.replace(landingUrl)}>작업공간 열기</button>
      )}

      {message && <p className={landingUrl ? "claim-success" : "error"}>{message}</p>}
    </section>
  );
}

export function captureStaffClaimToken(){
  const token=new URLSearchParams(window.location.search).get("token");
  if(window.location.pathname==="/access/claim" && token){
    window.sessionStorage.setItem(STAFF_CLAIM_KEY,token);
  }
}
